import cn from 'classnames'
import React from 'react'
import { IEnum_Solution_Item_Type, ISolutionListItemFragment } from 'src/graphql/generated/hooks'

import { GraveyardListItem } from '../GraveyardListItem/GraveyardListItem'
import { ConsolidationListItem } from './ConsolidationListItem/ConsolidationListItem'

export interface ConsolidationListProps {
  items: ISolutionListItemFragment[]
  topic?: string
  type: string
  className?: string
}

export const ConsolidationList: React.FC<ConsolidationListProps> = ({ items, topic, type, className = '' }) => {
  return (
    <div className={cn(className, 'flex flex-col bg-white', 'border-y', 'border-zinc-300')}>
      {type === 'consolidations' && (
        <div className="w-full h-[51px] bg-softPeach">
          <div className="flex flex-row w-full h-full">
            <p className="flex h-full items-center font-primary font-bold text-[14px] leading-[17px] text-darkgray ml-[10px] md:w-[115px] w-1/4">
              DATE
            </p>
            <p className="flex h-full items-center font-primary font-bold text-[14px] leading-[17px] text-darkgray md:w-[125px] w-1/4">
              BUYER
            </p>
            <p className="flex h-full items-center font-primary font-bold text-[14px] leading-[17px] text-darkgray md:w-[195px] w-1/4">
              TARGET
            </p>
            <p className="flex h-full items-center font-primary font-bold text-[14px] leading-[17px] text-darkgray md:w-[355px] w-1/4">
              ARTICLES
            </p>
          </div>
        </div>
      )}
      <ul className="divide-y divide-zinc-300">
        {items.map((solution, index) => {
          const from = topic ? '?topic=' + topic : ''

          let hrefLink = ''
          if (solution.type === IEnum_Solution_Item_Type.Alsp) {
            hrefLink = '/alsps/' + solution.slug + from
          } else if (solution.type === IEnum_Solution_Item_Type.Consultancy) {
            hrefLink = '/consultants/' + solution.slug + from
          } else if (solution.type === IEnum_Solution_Item_Type.Product) {
            hrefLink = '/vendors/' + solution.slug + from
          } else if (solution.type === IEnum_Solution_Item_Type.Company) {
            hrefLink = '/companies/' + solution.slug + from
          }

          return (
            <li key={index}>
              {type === 'graveyard' ? (
                <GraveyardListItem solution={solution} href={hrefLink} />
              ) : (
                <ConsolidationListItem solution={solution} index={index} href={hrefLink} />
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
